module.exports = __webpack_public_path__ + "img/1514991376.99609f40.jpg";